import { ConditionLibraryModuleType, PermissionAction } from '@coin/shared/core/util-enums';
import { Store } from '@ngxs/store';
import { EmploymentConditionLibraryModuleSettings } from '@coin/shared/ecl/util';
import { PermissionsService } from './permissions.service';

type Settings<K extends ConditionLibraryModuleType> = EmploymentConditionLibraryModuleSettings[K];

export class EclViewAccessHelper {
  public static hasOnlyViewAccess(
    store: Store,
    settings: Settings<ConditionLibraryModuleType>,
    permissionsService: PermissionsService
  ): boolean {
    const isAdmin = permissionsService.hasPermissions(...settings.adminResources);
    if (isAdmin || permissionsService.isSuperAdmin()) {
      return false;
    }

    const isEclUser = permissionsService.hasPermissions(...settings.readOnlyAccess);
    const allowedActions = [
      PermissionAction.All,
      PermissionAction.Create,
      PermissionAction.Update,
      PermissionAction.Delete
    ];
    const hasOnlyReadAccess =
      permissionsService.hasPermissionsAndActions({
        resources: settings.readOnlyAccess,
        actions: [PermissionAction.Read]
      }) &&
      !permissionsService.hasPermissionsAndActions({ resources: settings.readOnlyAccess, actions: allowedActions });

    return isEclUser && hasOnlyReadAccess;
  }
}
